import Vue from 'vue'
import App from './App.vue'
import store from './store/app.store'
import * as VueGoogleMaps from 'vue2-google-maps'
import PerfectScrollbar from 'vue2-perfect-scrollbar'
import Geocoder from '@pderas/vue2-geocoder'
import 'vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faLocationArrow, faMapMarkedAlt, faCalendar, faTimes, faSearch, faPhoneAlt, faMapMarkerAlt, faMapMarker, faCalendarWeek, faCheck, faPen } from '@fortawesome/free-solid-svg-icons'

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import VueProgressBar from 'vue-progressbar'
import VueScrollTo from 'vue-scrollto'

library.add(faLocationArrow, faCalendar, faMapMarkedAlt, faSearch, faTimes, faPhoneAlt, faMapMarkerAlt, faMapMarker, faCalendarWeek, faCheck, faPen)

Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.config.productionTip = false

/* eslint-disable-next-line */
Vue.use(VueGoogleMaps, {
    load: {
        key: (typeof drupalSettings.api_key !== 'undefined' ) ? drupalSettings.api_key : process.env.API_KEY,
        libraries: 'places,geometry',
        language: 'de'
    }
})

/* eslint-disable-next-line */
Vue.use(VueProgressBar, {
    color: 'rgb(255, 224, 1)',
    failedColor: 'red',
    thickness: '10px',
    position: 'relative',
    transition: {
        speed: '0.4s',
        opacity: '0.6s',
        termination: 50
    }
})

/* eslint-disable-next-line */
Vue.use(PerfectScrollbar)

/* eslint-disable-next-line */
Vue.use(VueScrollTo)

const apps = [...document.querySelectorAll(`.vue-store`)]

apps.forEach((app) => {
    /* eslint-disable-next-line */
  const $el = $$(app)
    /* eslint-disable-next-line no-new */
    new Vue({
        el: '.vue-store',
        data: {
            appName: $el.data(`app`),
            id: $el.data(`id`)
        },
        store,
        render: h => h(App)
    })
})
